// extracted by mini-css-extract-plugin
export default {"card":"adminDashboard_card__p6Pbc","icon":"adminDashboard_icon__xrN9s","cardTitle":"adminDashboard_cardTitle__fJ7si"};